module.exports = __webpack_public_path__ + "img/girl-body-back.def846ce.png";